module.exports = __webpack_public_path__ + "static/media/map.2384e538.png";